import { colors } from './constants';

export const getColor: (index: number) => string = (index) => {
    return index > colors.length - 1 ? colors[index % colors.length] : colors[index];
}
